import isUUID from 'validator/lib/isUUID';

import { strim } from '@utils/string';

import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';

export class UuidValidator extends BaseValidator {
    static key = 'uuid';

    static validator(value, label = 'UUID') {
        value = strim(value);

        if (!value) {
            return true;
        }

        if (isUUID(value)) {
            return true;
        }

        return i18n.t('validator.uuid', { field: label });
    }

    static arguments() {
        return [];
    }
}

export default UuidValidator;
